<template>
  <Container type="card-full">
    <div slot="header">
      <el-button v-if="type === 1 || type === 2" @click="save" :loading="btnLoading">保存</el-button>
      <el-button  @click="close">关闭</el-button>
    </div>
    <div>
      <el-form :model="pod" label-position="left" label-width="60px">
        <el-row>
          <el-col :span="5">
            <el-form-item label="单号">
              <el-input v-model="pod.podno" :maxlength="20" :disabled="disable"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10" style="margin-left: -50px;" >
            <el-form-item label="" v-if="type !== 1" >
              <doc-status :form="{docid: pod.podid,doctid: pod.poddoctid,
                                    docno: pod.podno, docdate: pod.poddate,
                                    docstatcheckstatusname:pod.docstatcheckstatusname,
                                    docstatnextcheckdesc:pod.docstatnextcheckdesc,
                                    returnForm: 'podForm'}"></doc-status>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="5">
            <el-form-item label="供应商">
              <el-select v-model="pod.podcvid" :clearable="true" :disabled="disable">
                <el-option v-for="(item, index) in cvList" :label="item.cvname" :value="item.cvid" :key="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="7" style="margin-left: 80px;">
            <el-form-item label="日期">
              <el-date-picker v-model="pod.poddate" type="date" placeholder="选择日期" :disabled="disable"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="15">
            <el-form-item label="备注">
              <el-input v-model="pod.podremark" :maxlength="255" type="textarea" :disabled="disable"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <vggrid ref="xGrid" :list="list" tableheight="500" flexname="poditemflex"
              :showfooter="true" :showPage="false" :resizable="true"
              :needBlackRow="true" :needPopMenu="true" :canbeEdit="!disable"
              @cellClick="cellClick" @editActived="cellActived">
      </vggrid>
    </div>
  </Container>
</template>

<script>
  import request from '@/utils/request'
  import utils from '../../assets/js/utils'
  import vggrid from '../common/vggrid'
  import DocthIndex from "../common/docthIndex";
  import DocStatus from "../common/docStatus.vue";
  export default {
    name: "podform",
    data () {
      return {
        poditem: {},
        pod: this.$route.params.form,
        type: Number(this.$route.params.type),
        disable: this.$route.params.type === 3 || this.$route.params.form.docstatcheckval !==1 ? true : false,
        list: [],
        btnLoading: false,
        cvList: []
        //unitList: [],
        //lebcList: [],
//        cols: [
//          { type: 'index',fieldtype: 'I', title: '行号',calculExpr:'', width: 80 },
//          { field: 'poditemlebcid', fieldtype: 'C', hide: true, title: '货物编码ID',calculExpr:'',editRender: { name: 'select', options: this.lebcList}},
//          { field: 'lebccode', fieldtype: 'C', brows: 'lebc',getvaluestr: ['lebcid','lebccode','lebcname','unitid'],setvaluestr: ['poditemlebcid','lebccode','lebcname','poditemunitid'], title: '货物编码',calculExpr:'',editRender: { name: 'ElInput', props: { readonly: true, suffixIcon: 'el-icon-search'}}},
//          { field: 'lebcname', fieldtype: 'C',  title: '货物名称',calculExpr:''},
//          { field: 'poditemunitid', fieldtype: 'C',  title: '计量单位',calculExpr:'',editRender: { name: 'ElSelect', options: this.unitList}},
//          { field: 'poditemqty', fieldtype: 'F',  triggercol:1, title: '数量', issum: true,calculExpr:'',editRender: { name: 'input'}},
//          { field: 'poditemprice', fieldtype: 'F',  triggercol:1, title: '单价',calculExpr:'',editRender: { name: 'input'}},
//          { field: 'poditemamt', fieldtype: 'F',  title: '金额', issum: true,calculExpr:'poditemqty*poditemprice'},
//          { field: 'poditemremark', fieldtype: 'C',  title: '备注',calculExpr:'',editRender: { name: 'input'}}
//        ]
      }
    },
    activated () {
      this.init()
      this.getCvList()
      this.getDocno()
    },
    created() {
//      console.log('created')
//      this.pod = this.$route.params.form
//      this.type = Number(this.$route.params.type)
//      this.disable = this.$route.params.type === 3 || this.$route.params.form.docstatcheckval !==1 ? true : false
//      this.list = []
//      this.getCvList()
//      this.getDocno()
    },
    mounted () {
    },
    watch: {
    },
    filters: {
    },
    components: {
      DocStatus,
      DocthIndex,
      vggrid},
    methods: {
      async init(){
        this.pod = this.$route.params.form
        this.type = Number(this.$route.params.type)
        this.disable = this.$route.params.type === 3 || this.$route.params.form.docstatcheckval !==1 ? true : false
        this.list = []
      },
      async getDocno () {
        if (this.pod.podid === 0) {
        } else {
          this.getPodItemList()
        }
      },
      async getCvList () {
        this.cvList = await request({
          method: 'get',
          url: '/basic/cv/getCvList',
          params: {comid: this.$store.getters.loginUser.usercomid}
        })
      },
      async cellActived (row) {
      },
      async cellClick (row) {
        this.poditem = row.row
      },
      async getPodItemList () {
        this.loading = true
        let res = await request({
          method: 'get',
          url: '/cggl/pod/getPodItemList',
          params: {podid: this.pod.podid}
        })
        this.list = res
        this.loading = false
      },
      async save () {
        this.pod.userid = this.$store.getters.loginUser.userid
        let model = {
          pod: this.pod,
          poditems: this.$refs.xGrid.$refs.xGrid.getRecordset()
        }
        await this.addOrEdit(model)
      },
      async addOrEdit (model) {
        let data = await request({
          url: '/cggl/pod/addOrEdit',
          method: "post",
          data: model
        })
        if (data.issuccess===1) {
          this.close()
          this.$message.success('保存成功')
        } else {
          this.$message.error('保存失败')
        }
      },
      close () {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: 'podIndex'})
      }
    }
  }
</script>

<style scoped>

</style>
